export default "__VITE_ASSET__135R36UH__"